/**
 * One scroll lock for the whole app, counted rather than assigned.
 *
 * Every overlay used to stash `document.body.style.overflow` on the way in and
 * put it back on the way out. That is correct exactly while no two overlays
 * overlap: open a sheet from inside a sheet and the inner one saves "hidden" as
 * the value to restore, so closing both leaves the body locked and the page
 * underneath dead to the touch — with nothing on screen to explain why.
 *
 * A count cannot get into that state. The lock lifts when the last holder lets
 * go, and it lifts to nothing rather than to whatever it happened to find.
 */
let holders = 0;

export function lockScroll(): () => void {
  holders++;
  document.body.style.overflow = 'hidden';

  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders = Math.max(0, holders - 1);
    if (holders === 0) document.body.style.overflow = '';
  };
}
